<template>
  <div class="fuwenben">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <!-- <div class="tit">
      <h3>录取查询</h3>
    </div> -->
    <div class="survey edit" v-html="data"></div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  metaInfo() {
    return {
      title: "录取查询-韩国东国大学中文官网",
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: "东国大学硕士录取查询,东国大学录取查询,东国大学录取查询系统",
        },
        {
          hid: "description",
          name: "description",
          content: "韩国东国大学中文官网为留学生提供录取查询服务包含东国大学录取查询、东国大学硕士录取查询、影像制作学录取查询等，韩国东国大学中文官网全程为您的韩国留学生涯保驾护航。",
        },
      ],
    };
  },
  name: "survey",
  data() {
    return {
      data: null,
    };
  },
  activated() {
    this.$emit("handleTKD", "录取查询");
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 421,
        })
        .then((res) => {
          this.data = res.data.Data.list[0].HtmlBody;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fuwenben {
  margin-top: 134px;
  // padding-top: 60px;
  width: 100%;
  .tit {
    h3 {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 600;
      color: #333333;
      text-align: center;
      margin-bottom: 40px;
    }
  }
  // 富文本样式
  .survey {
    letter-spacing: 1px;
    // padding: 0 30px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #444444;
    line-height: 40px;
    // padding-bottom: 30px;
    // padding-top: 30px;
    padding: 30px 40px 30px 40px;
    box-sizing: border-box;
    /deep/img {
      object-fit: cover;
      max-width: 100%;
      height: 100%;
    }
  }
}
</style>
